import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useWarehouseOrderExtraService from '../../../app/services/hooks/useWareHouseOrderExtraServicesService';
import { WarehouseExtraServiceDataForm } from '../../../app/models/WareHouseQuoteExtraService';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import { ItemCategory } from '../../../app/models/ItemCategory';
import { ServiceDataForm } from '../../../app/models/Service';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseOrderExtraServiceForm from './forms/WareHouseOrderExtraServicesForms/WareHouseOrderExtraServicesForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    extraServiceId: number
    onSaved: () => void;
    onCancel: () => void;
}

const WarehouseOrderExtraServiceEdit = ({ 
    extraServiceId,
    onSaved,
    onCancel,
}: Props) => {
    const { editWarehouseOrderExtraService, updateWarehouseOrderExtraService } = useWarehouseOrderExtraService();
    const [extraServiceform, setExtraServiceform] = useState<WarehouseExtraServiceDataForm>({
    });
    const [disableUpdate, setDisableUpdate] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [itemCategories, setItemCategories] = useState<ItemCategory[]>([]);
   
    const [services, setServices] = useState<ServiceDataForm[]>([]);
   
    useEffect(() => {
            edit();
        }, [extraServiceId]);
    const edit = () => {
        editWarehouseOrderExtraService(extraServiceId, {
            onSuccess: (response: ServiceResponse) => {
                setExtraServiceform(response.data.warehouse_order_extraservice);
                setServices(response.data.services);
                setCurrencies(response.data.currencies);
                setItemCategories(response.data.item_categories);
                setUnits(response.data.units);
                setDisableUpdate(false);
                setIsEdit(true);
            },
            onError: (response: ServiceResponse) => {
                toast.error('Error al cargar almacenamiento');
            }
        });
    };
    const update = () => {
        updateWarehouseOrderExtraService(extraServiceId, extraServiceform, {
            onSuccess: (response: ServiceResponse) => {
                toast.success(response.message);
                onSaved();
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                // Manejo de errores por campo si es necesario
            }
        });
    };

    return (
        <>
            <WarehouseOrderExtraServiceForm
                extraServiceForm={extraServiceform}
                setExtraServiceForm={setExtraServiceform}
                // depots={[]}
                itemCategories={[]}
                disabled={false} 
                currencies={currencies} 
                units={units} 
                services={services}            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default WarehouseOrderExtraServiceEdit;
